import { KeyValue } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount, take } from 'rxjs/operators';

export const CHANGE_DELIVERY_ADDRESS = 'shimano.delivery.address.enabled';
export const DISABLED_SITES = 'shimano.disabled.sites';

@Injectable({
  providedIn: 'root',
})
export class BaseSiteConfigService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  cacheWindowTime = 3600000;
  private cachedBaseSiteConfigValues$: any = {};

  constructor(protected http: HttpClient, private occEndpointsService: OccEndpointsService) {}

  getBaseSiteConfigValues$(_keys: string | string[]): Observable<any> {
    const keysArray = [].concat(_keys);
    const keys = keysArray.join();
    let httpParams = new HttpParams();
    httpParams = httpParams.append('enableFallback', 'true');
    httpParams = httpParams.append('fields', 'DEFAULT');
    httpParams = httpParams.append('keys', keys);

    const httpOptions = {
      headers: this.headers,
      params: httpParams,
    };

    if (!this.cachedBaseSiteConfigValues$[keys]) {
      this.cachedBaseSiteConfigValues$[keys] = this.http
        .get(this.occEndpointsService.buildUrl(`/config`), httpOptions)
        .pipe(
          publishReplay(1, this.cacheWindowTime),
          refCount(),
          take(1),
          map((data: any) => (!data.configs.length ? this.setDefaultBaseSiteConfigValues(keysArray) : data.configs)),
          catchError(this.errorHandl)
        );
    }

    return this.cachedBaseSiteConfigValues$[keys];
  }

  private setDefaultBaseSiteConfigValues(keys: string[]): KeyValue<string, string>[] {
    let defaultValue: KeyValue<string, string>[] = [];
    keys.forEach((key) => {
      switch (key) {
        case CHANGE_DELIVERY_ADDRESS:
          defaultValue.push({ key, value: 'true' });
          break;
        case DISABLED_SITES:
          defaultValue.push({ key, value: '' });
          break;
      }
    });
    return defaultValue;
  }

  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
